import { Timestamp } from '@/Types';

export const secondsToMilliseconds = (seconds: Timestamp): Timestamp => {
    return seconds * 1000;
};
